<template>
  <!--  서브페이지  -->

  <!--콘텐츠 영역-->
  <div id="sub_contents" class="sub_contents">

    <a @click="btnWrite" v-if="isAdmin" class="admin writing">팝업 공지 추가</a>

    <p v-if="!isAdmin">
      로그인이 필요합니다.
    </p>


    <div class="News_list">

      <ul class="list">
        <li v-for="(obj, index) in popupList" :key="index">
          <a @click="btnDetail(obj)">
            <dl>
              <dd class="img" v-if="obj.MAIN_IMG">
                <img :src="obj.MAIN_IMG" width="200"/>
              </dd>
              <dt>{{ obj.title }}</dt>
              <dd>생성일 : {{ obj.createdAt | date }}</dd>
              <dd>게시기간 : {{ obj.startDt | date }} ~ {{ obj.endDt | date }}</dd>
            </dl>
          </a>
        </li>
      </ul>
    </div>

    <router-view />

  </div>
</template>

<script>
import pm from "../common/protocolManager";
export default {
  data: () => ({
    message: "PopupList.vue",
    isAdmin: false,
    popupList : [],
  }),
  methods: {
    getList() {

      let url = "popupList";
      pm.get(url)
        .then(result => {

          if (result.list.length) {
            for (let i = 0; i < result.list.length; i++){
              let item = result.list[i];
              if (item.files && item.files.popupImage && item.files.popupImage.length) {
                item.MAIN_IMG = pm.NAS_URL + item.files.popupImage[0].filename;
              }
              this.popupList.push(item);
            }
          }

        })
        .catch(err => {
          console.log('popupList = err');
        });

    },
    btnDetail(obj) {
      this.$router.push({
        path: `/notice/popupdetail`,
        query: {
          id: obj._id,
        }
      });
    },
    btnWrite() {
      this.$router.push({
        path: `/notice/PopupWritePopup`,
      });
    },
    checkAdmin() {
      let url = "isAdmin";
      pm.get(url)
        .then(result => {
          console.log('isAdmin = true');
          this.isAdmin = true;
        })
        .catch(err => {
          console.log('isAdmin = err');
          this.isAdmin = false;
          if (localStorage.authToken) {
            localStorage.removeItem("authToken");
          }
        });
    },

  },
  computed: {

    IS_MOBILE() {
      return this.$root.$data.isMobileMode;
    },

  },
  destroyed() { },
  mounted() {
    this.checkAdmin();
    this.getList();
  },
  created() {
    import("../common/eventBus").then((module) => {
      let eventBus = module.default;
      eventBus.$on("EVENT_CHANGE_POPUP_LIST", () => {
        this.popupList = [];
        this.getList();
      });
    });
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/sub02/PopupList.vue